import {createContext, use, type ReactNode} from "react";

import type {HelpField} from "../types";

import useScreenHelp from "../hooks/use-screen-help";

type HelpScreenContextValue = {
  domain: string;
  screen: string;
  fieldsByKey: Map<string, HelpField>;
  isPending: boolean;
  isError: boolean;
};

const HelpScreenContext = createContext<HelpScreenContextValue | null>(null);

export function HelpScreenProvider({
  domain,
  screen,
  enabled = true,
  children,
}: {
  domain: string;
  screen: string;
  enabled?: boolean;
  children: ReactNode;
}) {
  const {fieldsByKey, isPending, isError} = useScreenHelp(domain, screen, enabled);

  return (
    <HelpScreenContext
      value={{
        domain,
        screen,
        fieldsByKey,
        isPending,
        isError,
      }}
    >
      {children}
    </HelpScreenContext>
  );
}

export function useHelpScreenContext() {
  const context = use(HelpScreenContext);
  if (!context) {
    throw new Error("useHelpScreenContext must be used within HelpScreenProvider");
  }
  return context;
}

export function useOptionalHelpScreenContext() {
  return use(HelpScreenContext);
}
